module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADASURBVHgB7dfBDQIhEAXQj7EAbYDQkXagHagVmK1AtwPtgJIMNLAVgHPEGLh4GCT/JYRkdg5z2PwMABER0chM7YO19ibXGbruIYRLWWgNnNEBGfhjxnWjdzLG7HLOG+iZQTSYVkpc5TpC10NSYioLY8WanAN0PUE0mGpKOOdOKSXNbW2R4/8+1laN3h42JW5rNJxmrMnzaA9FEqtzjNGXtd5jbZFY25aFaqzJA9RD39e2Zlrd8ls4KHoJEBER/eINfCw7fm090RYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu.png
// module id = +HEJ
// module chunks = 1